module.exports = __webpack_public_path__ + "4c3d15d5.svg";